import { pushDebugEntry, routeSnapshot } from '@/utils/debugLogHub';

/**
 * Errores de Vue, promesas no manejadas, errores de carga de script/recurso.
 */
export function installDebugLogHandlers(app) {
  const prevError = app.config.errorHandler;
  app.config.errorHandler = (err, instance, info) => {
    try {
      pushDebugEntry({
        type: 'error',
        title: err?.message || 'Error en la aplicación',
        body: err ? String(err) : '',
        stack: err?.stack || '',
        vueInfo: info || '',
        route: routeSnapshot(),
      });
    } catch {
      /* noop */
    }
    if (typeof prevError === 'function') prevError(err, instance, info);
    else console.error(err);
  };

  const prevWarn = app.config.warnHandler;
  app.config.warnHandler = (msg, instance, trace) => {
    try {
      pushDebugEntry({
        type: 'warn',
        title: String(msg),
        body: trace || '',
        route: routeSnapshot(),
      });
    } catch {
      /* noop */
    }
    if (typeof prevWarn === 'function') prevWarn(msg, instance, trace);
    else console.warn(msg);
  };

  window.addEventListener('unhandledrejection', (ev) => {
    const reason = ev.reason;
    const msg = reason instanceof Error ? reason.message : String(reason);
    const stack = reason instanceof Error ? reason.stack : '';
    pushDebugEntry({
      type: 'error',
      title: 'Promise rechazada (no manejada)',
      body: msg,
      stack,
      route: routeSnapshot(),
    });
  });

  window.addEventListener('error', (ev) => {
    if (ev.defaultPrevented) return;
    const fn = ev.filename || '';
    if (fn.startsWith('chrome-extension://') || fn.startsWith('moz-extension://')) return;
    pushDebugEntry({
      type: 'error',
      title: ev.message || 'Error en ventana',
      body: [ev.filename && `Archivo: ${ev.filename}`, ev.lineno && `Línea: ${ev.lineno}`, ev.colno && `Col: ${ev.colno}`]
        .filter(Boolean)
        .join('\n'),
      route: routeSnapshot(),
    });
  });
}
